import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Button } from "semantic-ui-react";
import { useMyGlobal } from '../../component/GlobalData';
import axios from 'axios';

const PaymentPendingPage = ({ setCart }) => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(search);
  const orderId = query.get("order_id");
  const { token } = useMyGlobal()
  const [isLoading, setIsLoading] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [isDone, setIsDone] = useState(false)

  const checkOrderState = () => {
    if (!orderId || isLoading || isDone) return;
    setIsLoading(true)
    const param = new URLSearchParams()
    param.append('id_order', orderId)
    axios({
        method: "POST",
        url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php?index=25`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': token
        },
        data: param
    })
    .then(response => {
      setIsValid(response.data?.isValid ?? false);
      if (response.data?.isValid) {
        const cartStructure = {
          customer: {
            address: null
          },
          products: [],
          selected_voucher: [],
          summary: {
            totalItem: 0,
            totalPrice: 0,
            total_order: 0,
            voucher: 0,
            voucher_ongkir: 0,
            kurir: null,
            service: null,
            service_cost: 0,
            total_weight: 0,
            order_id: null,
            id_cart: null,
            date: null,
            asuransi: 0,
          }
        }
        setCart(cartStructure)
        setIsDone(true);
      }
    })
    .catch(err => {
      setIsValid(false)
    })
    .finally(() => {
      setIsLoading(false)
    });
  }

  useEffect(() => {
    if (isDone) return;

    const id = setInterval(() => {
      checkOrderState();
    }, 5000);

    return () => clearInterval(id);
  }, [isDone]);

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "70vh" }}
    >
      {!isValid ?         
        <>
          <h2 style={{ fontWeight: 600 }}>⚠ Payment Pending</h2>
          <p style={{ fontSize: "18px", marginTop: "10px" }}>
            We noticed your payment for{" "}
            <strong>Order #{orderId ?? "Unknown"}</strong> is not completed yet.
            <br />
            Please finalize your payment to continue processing your order.
          </p>
        </>
        :
        <>
          <h2 className="ui header orange" style={{ fontWeight: 600}}>🎉 Payment Completed</h2>
          <p style={{ fontSize: "18px", marginTop: "10px" }}>
            Great news! Your payment for <strong>Order #{orderId ?? "Unknown"}</strong> has been confirmed.
            <br />
            We’ve started processing your order. Thanks for shopping with us!
          </p>
        </>
      }
      
      <Button content="Back to Home" color='orange' icon="home" size='tiny' labelPosition='right' onClick={() => navigate('/')} />
    </Container>
  );
};

export default PaymentPendingPage;
